import React from 'react';

const RequestLocation = ({ mapRef }) => {
  return (
    <>
      <div id="map" ref={mapRef}></div>
    </>
  );
};

export default RequestLocation;
